import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export function usePaginationUrl(pageParam = 'page', searchParam = 'search') {
  const [searchParams, setSearchParams] = useSearchParams()

  const page = Math.max(1, parseInt(searchParams.get(pageParam) ?? '1', 10) || 1)
  const search = searchParams.get(searchParam) ?? ''

  const setPage = useCallback((n: number) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev)
      if (n <= 1) {
        next.delete(pageParam)
      } else {
        next.set(pageParam, String(n))
      }
      return next
    }, { replace: true })
  }, [setSearchParams, pageParam])

  const setSearch = useCallback((s: string) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev)
      if (s) {
        next.set(searchParam, s)
      } else {
        next.delete(searchParam)
      }
      next.delete(pageParam)
      return next
    }, { replace: true })
  }, [setSearchParams, searchParam, pageParam])

  const clampPage = useCallback((totalPages: number) => {
    const maxPage = Math.max(1, totalPages)
    if (page > maxPage) {
      setPage(maxPage)
      return true
    }
    return false
  }, [page, setPage])

  return { page, setPage, search, setSearch, clampPage }
}
